"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An entity from OSRS which can be opened (e.g. implings)
 */
class Openable {
    constructor(options) {
        var _a;
        this.id = options.id;
        this.name = options.name;
        this.aliases = (_a = options.aliases) !== null && _a !== void 0 ? _a : [];
    }
}
exports.default = Openable;
//# sourceMappingURL=Openable.js.map